"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _AE_ORGANIZATION_SUBSCRIPTION_LEVEL = require("./AE_ORGANIZATION_SUBSCRIPTION_LEVEL");

var _AE_ORGANIZATION_SUBSCRIPTION_LEVEL2 = _interopRequireDefault(_AE_ORGANIZATION_SUBSCRIPTION_LEVEL);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Plans
// AE_ORGANIZATION_SUBSCRIPTION_PLANS
exports.default = [{
  level: _AE_ORGANIZATION_SUBSCRIPTION_LEVEL2.default.BASIC,

  // Monthly cost per currency.
  price: {
    USD: 0,
    CAD: 0
  },

  // Usage limits.
  limits: {
    // Maximum amount of lots per auction.
    maxLotsPerAuction: 50,

    // Maximum amount of pictures per lot.
    maxPicturesPerLot: 1
  }
}, {
  level: _AE_ORGANIZATION_SUBSCRIPTION_LEVEL2.default.PREMIUM,
  price: {
    USD: 48,
    CAD: 48
  },
  limits: {
    maxLotsPerAuction: 2500,
    maxPicturesPerLot: 20
  }
}]; /**
     * Copyright 2013-present, Novivia, Inc.
     * All rights reserved.
     */

module.exports = exports["default"];


//////////////////
// WEBPACK FOOTER
// /private/var/folders/n9/yczdnstj3wdc9q5tzm6d45c00000gp/T/maison-encans-auex-website/~/@auex/configurations/lib/common/AE_ORGANIZATION_SUBSCRIPTION_PLANS.js
// module id = 65
// module chunks = 9 10 11 12 13 14 15 18 19 20 21 22 23 24 25 26 27 28 29 30 33 34 35 38 39 40 41 42 43 45 46 47 48 49 50 51 54